var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Card',{staticClass:"cardDiv"},[_c('p',{attrs:{"slot":"title"},slot:"title"},[_vm._v("组织名称："+_vm._s(_vm.currentData.organizationName))]),_c('Tree',{attrs:{"data":_vm.treeData_select}})],1),_c('div',{staticClass:"ml-5 mt-5 text-center modal-foter"},[_c('Button',{on:{"click":_vm.returnBack}},[_vm._v("关 闭")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }